import styled from 'styled-components';

export const DescriptionContainer = styled.div`
  margin: 8px 0 0 0;
`;
